import LocalCookieStorage from '@/service/localCookieStorage';
import Checkbox from '@/components/Form/Checkbox/index.vue';
import { ONE_YEAR } from '@/constants/constants';


export default {
  name: 'CookiePolicy',

  components: {
    Checkbox,
  },

  methods: {
    selectAllCookie(state) {
      this.isAllCookie = state;
      this.isError = false;

      if (state) {
        this.isOnlyNecessaryCookie = false;
      }
    },

    selectNecessaryCookie(state) {
      this.isOnlyNecessaryCookie = state;
      this.isError = false;

      if (state) {
        this.isAllCookie = false;
      }
    },

    saveSettings() {
      let type = '';

      if (this.isAllCookie) {
        type = 'all';
      }

      if (this.isOnlyNecessaryCookie) {
        type = 'necessary';
      }

      if (!type) {
        this.isError = true;
        return;
      }

      LocalCookieStorage.set('cookie-allow', type, ONE_YEAR);
      this.$store.commit('changeCookieAllowState', type);
      this.$router.push('sign_in');
    },
  },

  data() {
    return {
      isAllCookie: this.isAllCookie,
      isOnlyNecessaryCookie: this.isOnlyNecessaryCookie,
      isError: false,
    };
  },
};
